import React from "react";
import { IContentHeader } from "./content-header.types";

const ContentHeader = ({ children }: IContentHeader) => {
  return <div className="mb-8">{children}</div>;
};

export default ContentHeader;
